import { c as _c } from "react/compiler-runtime";
import { Button } from "@flat-ui";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useShouldShowAddCredits } from "@hooks/use-should-show-add-credits";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** Component to show the button add credits */
export function AddCredits() {
  const $ = _c(4);
  const {
    trackEvent
  } = useTrackEvent();
  const companyId = useCompanyId();
  const {
    navigateToCreditsPage
  } = useAppNavigation();
  const {
    shouldShowAddCredits
  } = useShouldShowAddCredits();
  if (!shouldShowAddCredits) {
    return null;
  }
  let t0;
  if ($[0] !== companyId || $[1] !== navigateToCreditsPage || $[2] !== trackEvent) {
    const handleAddCredits = function handleAddCredits() {
      trackEvent({
        name: WorkspaceEvents.openAddCreditsPage
      });
      navigateToCreditsPage({
        companyId
      });
    };
    t0 = <Button onClick={handleAddCredits}>Add {CREDITS_DISPLAY_NAME}</Button>;
    $[0] = companyId;
    $[1] = navigateToCreditsPage;
    $[2] = trackEvent;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}